module.exports = __webpack_public_path__ + "img/wulianwang (3).1a2a3db8.png";